import type { ISearchController } from "./interfaces/types";
import type { ISeptimaSearchResultItem } from "./interfaces/types";
import { getCvrSearch } from "../../api/cvr/queries";
import { mapCvrSearchHitsToSeptimaResults } from "../../api/cvr/mapping";

/**
 * Creates a search controller that uses the CVR REST API for virksomhed lookup.
 * Uses get from api/util via api/cvr/queries.
 */
export function createCvrSearchController(): ISearchController {
  return {
    fetchData: (
      queryString: string,
      _completeCallback: Function | null,
      limit: number | null,
      _timeout: null,
      _source: string | null,
      _type: string | null,
    ): Promise<{ getAllResults: () => ISeptimaSearchResultItem[] }> => {
      if (!queryString?.trim()) {
        return Promise.resolve({ getAllResults: () => [] });
      }
      return getCvrSearch({
        q: queryString,
        limit: limit ?? 10,
      }).then((hits) => ({
        getAllResults: () => mapCvrSearchHitsToSeptimaResults(hits),
      }));
    },
  } as ISearchController;
}
